import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Redirect, Route } from "react-router-dom";
import Pricing from "./component/pages/Pricing";
// import ScheduleDemo from "./component/pages/ScheduleDemo";
import Solutions from "./component/pages/solutions/Solutions";
import Footer from "./component/common/Footer";
import Faq from "./component/pages/Policy/FAQ/Faq";
import Gdpr from "./component/pages/Policy/GDPR/Gdpr";
import Security from "./component/pages/Policy/Security/Security";
import Resource from "./component/pages/resource/Resource";
import ManagedServices from "./component/pages/Managed Services/ManagedServices";
import { Blog } from "./component/pages/blog/Blog";
// import { Policy1, Terms1 } from "./component/pages/Redirects";
import axios from "axios";
import WebFont from "webfontloader";
import IntegrationPage from "./component/pages/Integration/IntegrationPage";
import CloudInsights from "./component/pages/cloudInsights/CloudInsights";
import AllPricing from "./component/pages/AllPricing";
import Policy from "./component/pages/Policy/Policy";
import Terms from "./component/pages/Policy/Terms";
import Home1 from "./component/pages/Home/Home1";
import Home2 from "./component/pages/Home/Home2";

WebFont.load({
  google: {
    families: ["Montserrat Web:300,400,500,600,700,bold,bolder", "Montserrat"],
  },
});

const valueData = {
  set current(name) {
    this.log.push(name);
  },
  log: [],
};

// axios.get("https://api.ipify.org/?format=json").then((data) => {
//   let url = `https://ipapi.co/${data.data.ip}/json/`;
//   axios.get(url).then((re) => {
//     valueData.current = re.data.currency;
//   });
// });
// axios.get("https://api.db-ip.com/v2/free/self").then((data) => {
//   console.log(data.data.countryCode);
//   let url = `https://ipapi.co/${data.data.ipAddress}/json/`;
//   axios.get(url).then((re) => {
//   valueData.current = re.data.currency;
//   });
// });

axios.get("https://api.db-ip.com/v2/free/self").then((data) => {
  valueData.current = data.data.countryCode;
});

export const userContent = React.createContext();

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
    <React.StrictMode>
      <Router>
        <App />
        <Route exact path="/" component={Solutions} />
        <Route exact path="/solutions" component={Solutions} />
        <Route exact path="/home1" component={Home1} />
        <Route exact path="/home2" component={Home2} />
        <Route exact path="/blog" component={Blog} />
        <Route path="/blog/:blogTitle" component={Blog} />
        {/* <Route path="/schedule-demo" component={ScheduleDemo} /> */}
        <Route path="/resources/:data" component={Resource} />
        <Route path="/faqs" component={Faq} />
        <Route path="/gdpr" component={Gdpr} />
        <Route path="/security" component={Security} />
        <userContent.Provider value={valueData.log}>
          <Route path="/pricing" component={AllPricing} />
        </userContent.Provider>
        <userContent.Provider value={valueData.log}>
          <Route path="/detail-pricing" component={Pricing} />
        </userContent.Provider>
        {/* <Route path="/managed-services" component={ManagedServices} /> */}
        {/* <Route path="/schedule-service" component={ScheduleDemo} /> */}
        <Route path="/privacy-policy" component={Policy} />
        <Route path="/terms-of-service" component={Terms} />
        <Route exact path="/integration" component={IntegrationPage} />
        <Route path="/cloud-insights" component={CloudInsights} />
        {/* <Route exact path={["/test", "/search_gcse", "/hello-world"]}>
          <Redirect to="/" />
        </Route> */}
        <Route
          exact
          path={[
            // "/cloud-social-resources",
            // "/cloud-social-resources-2",
            // "/cloud-social-resources-3",
            "/resources",
          ]}
        >
          <Redirect to="/resources/literature" />
        </Route>
        {/* <Route exact path="/blog/2">
          <Redirect to="/blog" />
        </Route> */}
        {/* <Route exact path="/terms-privacy-policy-old">
          <Redirect to="/terms-of-service" />
        </Route> */}
        <Route exact path="/features">
          <Redirect to="/solutions" />
        </Route>
        {/* <Route exact path="/terms-privacy-policy-2">
          <Redirect to="/privacy-policy" />
        </Route>
        <Route exact path="/terms-privacy-policy-2-2">
          <Redirect to="/terms-of-service" />
        </Route> */}
        <Footer />
      </Router>
    </React.StrictMode>,
    rootElement
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <App />
        <Route exact path="/" component={Solutions} />
        <Route exact path="/solutions" component={Solutions} />
        <Route exact path="/home1" component={Home1} />
        <Route exact path="/home2" component={Home2} />
        <Route exact path="/blog" component={Blog} />
        <Route path="/blog/:blogTitle" component={Blog} />
        {/* <Route path="/schedule-demo" component={ScheduleDemo} /> */}
        <Route path="/resources/:data" component={Resource} />
        <Route path="/faqs" component={Faq} />
        <Route path="/gdpr" component={Gdpr} />
        <Route path="/security" component={Security} />
        <userContent.Provider value={valueData.log}>
          <Route path="/pricing" component={AllPricing} />
        </userContent.Provider>
        <userContent.Provider value={valueData.log}>
          <Route path="/detail-pricing" component={Pricing} />
        </userContent.Provider>
        {/* <Route path="/managed-services" component={ManagedServices} /> */}
        {/* <Route path="/schedule-service" component={ScheduleDemo} /> */}
        <Route path="/privacy-policy" component={Policy} />
        <Route path="/terms-of-service" component={Terms} />
        <Route exact path="/integration" component={IntegrationPage} />
        <Route path="/cloud-insights" component={CloudInsights} />
        {/* <Route exact path={["/test", "/search_gcse", "/hello-world"]}>
          <Redirect to="/" />
        </Route> */}
        <Route
          exact
          path={[
            // "/cloud-social-resources",
            // "/cloud-social-resources-2",
            // "/cloud-social-resources-3",
            "/resources",
          ]}
        >
          <Redirect to="/resources/literature" />
        </Route>
        {/* <Route exact path="/blog/2">
          <Redirect to="/blog" />
        </Route> */}
        {/* <Route exact path="/terms-privacy-policy-old">
          <Redirect to="/terms-of-service" />
        </Route> */}
        <Route exact path="/features">
          <Redirect to="/solutions" />
        </Route>
        {/* <Route exact path="/terms-privacy-policy-2">
          <Redirect to="/privacy-policy" />
        </Route>
        <Route exact path="/terms-privacy-policy-2-2">
          <Redirect to="/terms-of-service" />
        </Route> */}

        <Footer />
      </Router>
    </React.StrictMode>,
    rootElement
  );
}
